import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=ece73c00&"
import script from "./FormBuilder.vue?vue&type=script&lang=ts&"
export * from "./FormBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports